import { SideNav } from 'ui/sideNav';
import { SideNavStyle } from 'ui/sideNav/types';
import { useUserKey } from '../hooks';

const useLinksAndSections = () => {
  const userId = useUserKey();

  const links = [
    { name: 'User fields', pathname: `/users/profiles/${userId}/fields` },
    {
      header: 'Events',
      links: [
        { name: 'Summary', pathname: `/users/profiles/${userId}/event/summary` },
        { name: 'History', pathname: `/users/profiles/${userId}/event/history` },
      ],
    },
    { name: 'Subscriptions', pathname: `/users/profiles/${userId}/subscriptions` },
    { name: 'Lists', pathname: `/users/profiles/${userId}/lists` },
  ];

  return [{ header: 'USER PROFILE', links }];
};

export const UserProfilesSideNav = () => {
  return <SideNav linksAndSections={useLinksAndSections()} style={SideNavStyle.normal} isSticky />;
};
